import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcDownloadErrorIcon } from '@gem/icons';

import Tasks from 'APP/Tasks';
import { MediaPreview } from 'APP/components/MediaPreview/MediaPreview';
import { useFileDownloadStatePresenter } from 'APP/hooks/useFileDownloadState/useFileDownloadState';
import Entities from 'STORE';
import { ImagePayload } from 'STORE/Messages/Message/Payload/ImagePayload/ImagePayload';
import { VideoPayload } from 'STORE/Messages/Message/Payload/VideoPayload/VideoPayload';

import styles from './AllDownloadsMediaItemIcon.styles.m.css';

interface IAllDownloadsMediaItemIconProps {
  payloadId: string;
  groupId: string;
  messageId: string;
}

export const AllDownloadsMediaItemIcon: FC<IAllDownloadsMediaItemIconProps> = observer((props) => {
  const { payloadId, groupId, messageId } = props;
  const { payload, hasError } = useFileDownloadStatePresenter({
    payloadId,
    groupId,
    messageId,
  });

  return (
    <div className={styles.container}>
      <MediaPreview
        key={`all-downloads-media-item-${Entities.App.isOfflineNetworkStatus}`}
        className={styles.mediaPreview}
        downloadStateClassName={styles.downloadState}
        payload={payload as ImagePayload | VideoPayload}
        maxWidth={40}
        maxHeight={40}
        needCropImage={true}
        onClick={(): void =>
          Tasks.group.openMediaGallery({
            groupId,
            mediaId: payloadId,
            messageId,
          })
        }
        payloadId={payloadId}
        groupId={groupId}
        messageId={messageId}
        loadIconSize="0"
      />
      {hasError && (
        <>
          <IcDownloadErrorIcon className={styles.errorIcon} />
          <div className={styles.errorIconBorder} />
        </>
      )}
    </div>
  );
});
